import styled from "styled-components"

export const StyleSperator = styled.hr`
    margin-top: 100px;
    margin-bottom: 100px;
`;

export const StyleNoLineSperator = styled.div`
    margin-top: 100px;
    margin-bottom: 100px;
`;

export const StyleDivision = styled.h2`
    margin-bottom: 50px;
    font-weight: normal;
`;

export const StyleBadgeGreen = styled.span`
    display: inline-block;
    background-color: #2d8a4e;
    color: white;
    padding: 0px 7px;
    text-align: center;
    border-radius: 5px;
    margin: 2px;
    font-size:12px;
    font-weight: normal;
`;
